export default __webpack_public_path__ + "asset/img/taoke-flag-2~83580090.png";